export default "/assets/images/awards-img-01-sm.0e892e95c4c30764.svg";